import { BusinessGetResponseType } from "@sellar-io/api-v2/types";
import { CountryType } from "@sellar-io/common";

export type AddressFieldValues = {
  name: string;
  street: string;
  city: string;
  region: string;
  postalCode: string;
  country: CountryType;
};

export const generateAddressFieldValues = (
  address?: BusinessGetResponseType["DeliveryAddress"],
): AddressFieldValues => ({
  name: address?.name ?? "",
  street: address?.street ?? "",
  city: address?.city ?? "",
  region: address?.region ?? "",
  postalCode: address?.postalCode ?? "",
  country: address?.country ?? "GB",
});

export type BusinessAddressFieldValues = {
  DeliveryAddress: AddressFieldValues;
  isInvoiceAddressSame: boolean;
  isCollectionAddressSame: boolean;
  InvoiceAddress: AddressFieldValues;
  CollectionAddress: AddressFieldValues;
};

export const generateBusinessAddressFieldValues = (
  business?: Pick<
    BusinessGetResponseType,
    | "InvoiceAddressId"
    | "CollectionAddressId"
    | "DeliveryAddressId"
    | "DeliveryAddress"
    | "InvoiceAddress"
    | "CollectionAddress"
  >,
): BusinessAddressFieldValues => {
  const isInvoiceAddressSame =
    business?.InvoiceAddressId && business.DeliveryAddressId
      ? business.InvoiceAddressId === business.DeliveryAddressId
      : true;
  const isCollectionAddressSame =
    business?.CollectionAddressId && business.DeliveryAddressId
      ? business.CollectionAddressId === business.DeliveryAddressId
      : true;

  return {
    DeliveryAddress: generateAddressFieldValues(business?.DeliveryAddress),
    isInvoiceAddressSame,
    InvoiceAddress: generateAddressFieldValues(business?.InvoiceAddress),
    isCollectionAddressSame,
    CollectionAddress: generateAddressFieldValues(business?.CollectionAddress),
  };
};
